<template>
    <div id="report_modal" class="absolute" v-show="showModal">
        <div class="report_modal-content relative p-20">
            <vs-button class="close_modal absolute top-0 right-0 bg-white" color="black" radius type="border"
                       icon="close" @click="closeModal"></vs-button>
            <h2 class="font-light text-lg mb-5">Rapport d'activité</h2>
            <form>
                <div class="flex gap-4 mb-5">
                <vs-input type="date" name="start_date" id="start_date" class="mb-5" v-model="start_date"></vs-input>
                <vs-input type="date" name="end_date" id="end_date" class="mb-5" v-model="end_date"></vs-input>
                </div>
                <vs-button color="primary" type="border" icon-pack="far" icon="fa-download" class="download__button"
                           @click="getReport">
                    Télécharger
                </vs-button>
            </form>
            <div class="report_modal-upload">
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/axios.js'

export default {
    props: {
        showModal: Boolean,
        start_date: '',
        end_date: '',
    },
    methods: {
        closeModal() {
            this.$emit('close-modal', {boolean: false})
        },
        getReport() {
            if(!this.start_date || !this.end_date) {
                this.$vs.notify({
                    title: 'Erreur',
                    text: 'Veuillez remplir les champs',
                    color: 'danger',
                    position: 'top-right'
                })
                return
            }

            axios.get('/report',
                {
                    responseType: 'blob',
                    params: {
                        start_date: this.start_date,
                        end_date: this.end_date,
                    }
                }
            ).then(response => {
                const href = URL.createObjectURL(response.data)
                const link = document.createElement('a')
                link.href = href
                link.setAttribute('download', 'reports.xlsx')
                document.body.appendChild(link)
                link.click()

                document.body.removeChild(link)
                URL.revokeObjectURL(href)
            })
        },
    }
}
</script>

<style lang="scss" scoped>
#report_modal {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;

    .report_modal-content {
        background-color: #fff;
        width: 80%;
        max-width: 900px;

        .close_modal {
            transform: translate(50%, -50%);
        }

        .download__button {
            padding: 10px;
        }
    }
}
</style>
